import React from "react";
import * as constants from '../constants';
import CPSettingToggle from "../../../../UI/Settings/CPSettingToggle";

const PopUpViewMemberProfile = ({settings, onChange}) => {
    return (
        <>
            <p>
                <i>
                    Основные настройки прозрачности и размытия поп-апа во вкладке <b>Вид поп-ап "Описание эпизода"</b>
                </i>
            </p>
            <CPSettingToggle
                name={constants.SCHEDULE_SHOW_MEMBER_POPUP}
                isChecked={settings?.[constants.SCHEDULE_SHOW_MEMBER_POPUP]}
                label="Показывать поп-ап"
                onChange={onChange}
            />
            {
                settings?.[constants.SCHEDULE_SHOW_MEMBER_POPUP] &&
                <>
                    <p>
                        <b>
                            В активностях участника:
                        </b>
                    </p>
                    <CPSettingToggle
                        name={constants.SCHEDULE_MEMBER_POPUP_SHOW_FORMAT}
                        isChecked={settings?.[constants.SCHEDULE_MEMBER_POPUP_SHOW_FORMAT]}
                        label="Показывать формат"
                        onChange={onChange}
                    />
                    <CPSettingToggle
                        name={constants.SCHEDULE_MEMBER_POPUP_SHOW_STATUS}
                        isChecked={settings?.[constants.SCHEDULE_MEMBER_POPUP_SHOW_STATUS]}
                        label="Показывать статус"
                        onChange={onChange}
                    />
                    <CPSettingToggle
                        name={constants.SCHEDULE_MEMBER_POPUP_ADD_TO_CALENDAR}
                        isChecked={settings?.[constants.SCHEDULE_MEMBER_POPUP_ADD_TO_CALENDAR]}
                        label="Показывать кнопку 'Добавить в календарь'"
                        onChange={onChange}
                    />
                </>
            }
        </>
    );
};

export default PopUpViewMemberProfile;
